import React from 'react'
import { useSelector } from 'react-redux'
import {
  arrayOf,
  string,
  number,
  object,
  bool,
  oneOfType,
  shape,
} from 'prop-types'
import classnames from 'classnames'

import Carousel from 'src/Components/shared/Carousel'
import { selectClientFetchId } from 'src/store/selectors/client'
import { selectListingsSourceIsHomebotListings } from 'src/store/selectors/listings'
import Slide from './Slide'
import AdSlide from './AdSlide'
import LastSlide from './LastSlide'

import styles from './ListingsCarousel.module.scss'

const generateListingSlides = (
  listings,
  adSlide,
  adSlideIndex,
  includeFullAd,
  homebotListingsEnabled,
  clientId,
  slideClassName
) => {
  if (
    /* eslint-disable no-undef */
    adSlide &&
    homebotListingsEnabled &&
    typeof chrome !== 'undefined' &&
    chrome
  ) {
    listings.splice(adSlideIndex, 0, adSlide)
  }

  return listings.map(listing => {
    const { id } = listing
    let SlideComponent

    if (id === 'lastSlide') {
      SlideComponent = LastSlide
    } else if (id === 'chromebotAd') {
      SlideComponent = AdSlide
    } else {
      SlideComponent = Slide
    }

    return (
      <SlideComponent
        key={id}
        clientId={clientId}
        className={slideClassName}
        includeFullAd={includeFullAd}
        {...listing}
      />
    )
  })
}

const ListingsCarousel = ({
  className,
  listings,
  lastSlide,
  adSlide,
  adSlideIndex,
  includeFullAd,
  slidesToShow,
  slidesToScroll,
  responsive,
  slideClassName,
}) => {
  const homebotListingsEnabled = useSelector(
    selectListingsSourceIsHomebotListings
  )
  const clientId = useSelector(selectClientFetchId)
  const slides = generateListingSlides(
    listings,
    lastSlide,
    adSlide,
    adSlideIndex,
    includeFullAd,
    homebotListingsEnabled,
    clientId,
    slideClassName
  )

  return (
    <Carousel
      className={classnames(className, styles.listingCarousel)}
      slides={slides}
      arrows
      infinite={false}
      speed={300}
      swipeToSlide
      slidesToShow={slidesToShow}
      slidesToScroll={slidesToScroll}
      responsive={responsive}
    />
  )
}

ListingsCarousel.propTypes = {
  className: string,
  slideClassName: string,
  listings: arrayOf(
    shape({
      id: oneOfType([number, string]),
      mainPhoto: string,
      bedrooms: number,
      bathrooms: number,
      formattedPrice: string,
    })
  ),
  lastSlide: object,
  adSlide: object,
  adSlideIndex: number,
  includeFullAd: bool,
  slidesToShow: number,
  slidesToScroll: number,
  responsive: arrayOf(object),
}

ListingsCarousel.defaultProps = {
  adSlideIndex: 1,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 499,
      settings: {
        slidesToShow: 2,
        rows: 1,
        slidesToScroll: 1,
        infinite: true,
      },
    },
  ],
}

export default ListingsCarousel

export { AdSlide, Slide }
